import { render, staticRenderFns } from "./CallRecordsDownloadPolicy.vue?vue&type=template&id=2632f808&scoped=true&"
import script from "./CallRecordsDownloadPolicy.vue?vue&type=script&lang=js&"
export * from "./CallRecordsDownloadPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2632f808",
  null
  
)

component.options.__file = "CallRecordsDownloadPolicy.vue"
export default component.exports